import H1Principal from '../../atoms/text/H1Principal';

export default function TitleH1({ children, design = 'my-8' }) {
	return (
		<div className={`${design} mx-auto`}>
			<H1Principal design='text-center'>{children}</H1Principal>
		</div>
	);
}
